const parseErrMsgFromError = (error) => {
	if (!error) return "Unknown error occurred.";

	const responseData = error?.response?.data;
	if (responseData) {
		if (typeof responseData === "string" && responseData.trim()) return responseData;
		if (responseData.message) return responseData.message;
		if (responseData.error) return responseData.error;
		if (responseData.Error) return responseData.Error;
	}

	// Handle Sequelize Errors
	if (error.name && error.name.startsWith("Sequelize")) {
		const errorCode = error.original?.code || error.parent?.code || "No error code provided";
		switch (error.name) {
			case "SequelizeValidationError":
				return `Validation Error: ${error.errors.map((err) => err.message).join(", ")}`;
			case "SequelizeUniqueConstraintError":
				return `Unique Constraint Error: ${error.errors.map((err) => err.message).join(", ")}. Code: ${errorCode}`;
			case "SequelizeForeignKeyConstraintError":
				return `Foreign Key Constraint Error: Ensure referenced key exists. Code: ${errorCode}`;
			case "SequelizeDatabaseError":
				return `Database Error: ${error.message}. Code: ${errorCode}`;
			case "SequelizeConnectionError":
				return `Connection Error: ${error.message}. Code: ${errorCode}`;
			case "SequelizeTimeoutError":
				return `Timeout Error: ${error.message}. Code: ${errorCode}`;
			default:
				return `Sequelize Error: ${error.message}. Code: ${errorCode}`;
		}
	}
	// Handle Built-in JavaScript Errors
	if (error instanceof SyntaxError) {
		return `Syntax Error: ${error.message}`;
	} else if (error instanceof ReferenceError) {
		return `Reference Error: ${error.message}`;
	} else if (error instanceof TypeError) {
		return `Type Error: ${error.message}`;
	} else if (error instanceof RangeError) {
		return `Range Error: ${error.message}`;
	} else if (error instanceof URIError) {
		return `URI Error: ${error.message}`;
	} else if (error instanceof EvalError) {
		return `Eval Error: ${error.message}`;
	}

	// Axios network / status codes — prefer statusText when no API body message
	if (error.isAxiosError || error.name === "AxiosError") {
		if (error.response?.statusText) {
			return `Request failed (${error.response.status}): ${error.response.statusText}`;
		}
		if (error.message) return error.message;
	}

	// Handle Node.js Error Codes
	if (error.code) {
		switch (error.code) {
			case "ENOENT":
				return "File or directory not found.";
			case "EACCES":
				return "Permission denied.";
			case "ECONNREFUSED":
				return "Connection refused.";
			case "ETIMEDOUT":
				return "Operation timed out.";
			case "EADDRINUSE":
				return "Address already in use.";
			case "ECONNRESET":
				return "Connection reset by peer.";
			default:
				return `Error Code: ${error.code} - ${error.message || "No additional information."}`;
		}
	}

	// Generic Fallback for Unhandled Errors
	return `Error: ${error.message || String(error)}`;
};
export default parseErrMsgFromError;
